import React from 'react';
import { Checkbox, Input } from '@chargify/custom-ui-components';
import FilterBox, { FilterBoxProps } from '../FilterBox';
import { Product } from '../../../../models/billingHistory/billingHistory';

export interface ProductNameFilterProps
  extends Omit<FilterBoxProps, 'children'> {
  onChange: (values: number[]) => void;
  placeholder?: string;
  showSearch?: boolean;
  values?: number[];
  products: Product[];
}

export const ProductNameFilter = ({
  onChange,
  placeholder,
  values,
  showSearch,
  products,
  ...rest
}: ProductNameFilterProps) => {
  const [searchValue, setSearchValue] = React.useState('');
  const filteredProductNames = products?.filter(({ name }) =>
    name.toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <FilterBox {...rest}>
      {showSearch ? (
        <Input
          placeholder={placeholder}
          onChange={(e) => setSearchValue(e.target.value)}
          iconRight={'search'}
          value={searchValue}
          inputSize={'small'}
        />
      ) : null}
      {filteredProductNames?.map(({ name, id }) => (
        <Checkbox
          key={id}
          onChange={() => {
            if (!values.includes(id)) {
              onChange([...values, id]);
            } else {
              onChange(values.filter((status) => status !== id));
            }
          }}
          label={name}
          name={name}
          value={values?.includes(id)}
          id={name}
        />
      ))}
    </FilterBox>
  );
};
